<template>
  <v-container fluid>
    <v-row>
        <v-col cols="12" md="6" style="margin: auto;">
            <v-timeline dense>
            <v-timeline-item
                v-for="item in timelineData"
                :key="item.id"
                color="primary"
                small
            >
                <v-card class="pa-3">
                    <div>{{  item.show_date }}  - {{ item.documenttype_code?item.documenttype_code:"" }}</div>
                    <!-- {{ JSON.parse(item.documenttype_actions)[0]?JSON.parse(item.documenttype_actions)[0].documenttype_code:"" }} -->
                    <div v-for="datadocumenttype_actions in JSON.parse(item.documenttype_actions)" style="font-size: 0.8rem; color: gray;">- {{datadocumenttype_actions.name }}</div>
                    <br/>
                    <div class="d-flex justify-space-between" style="font-size: 0.7rem;color:blue">
                      <span v-if="item.fullnameen_user_create || item.fullnameth_user_create ">Create By : {{ item.fullnameen_user_create?item.fullnameen_user_create:item.fullnameth_user_create?item.fullnameth_user_create:"" }}</span>
                      <span v-if="item.fullnameen_user_update || item.fullnameth_user_update">Update By : {{ item.fullnameen_user_update?item.fullnameen_user_update:item.fullnameth_user_update?item.fullnameth_user_update:"" }}</span>
                    </div>
                </v-card>
            </v-timeline-item>
            </v-timeline>
        </v-col>
    </v-row>

    <SuccessDialog
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
    />
    <SuccessDialogPush
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
      :link="link"
    />
  </v-container>
</template>

<script>
import moment from 'moment-timezone';
import api from "@/services/api";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import pdfvuer from "pdfvuer";

export default {
  name: "MasterPatentNew",
  components: { SuccessDialog, SuccessDialogPush, pdf: pdfvuer },
  data() {
    return {
      dialogAdd: false,
      text_color: '',
      title: '',
      message: '',
      link: '',
      timelineData: [
        // { id: 1, event: "Start Project", date: "18/06/2025" },
        // { id: 2, event: "Design Phase", date: "19/06/2025"},
        // { id: 3, event: "Development Phase", date: "23/06/2025"},
        // { id: 4, event: "Testing", date: "28/06/2025"},
        // { id: 5, event: "Deployment", date: "03/07/2025"},
      ],
    };
  },
  async mounted() {
    await this.loadTimeline();
    this.$hideLoader();
  },
  methods: {
    async loadTimeline() {
      this.timelineData = [];
      this.$showLoader();
console.log(this.$route.params.masterpt_id);
const result = await api.gettimelinemasterpt({masterpt_id:this.$route.params.masterpt_id});
  if(result.data.length > 0){
      // this.timelineData = result.data;
result.data.forEach((x,i)=>{
this.timelineData.push(x);
if(JSON.parse(x.change_master_record_data_All).length > 0){
  x.documenttype_code = "";
  x.documenttype_code = (JSON.parse(x.change_master_record_data_All)?.map(item => item.field_name).join(" / ")) || "";
 
}
});
this.$hideLoader();
    }
    this.$hideLoader();
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
/* ปรับขนาด font ของเวลาหรือสีได้ตามต้องการ */
</style>
